import styled from 'styled-components';

export const Wrapper = styled.div`
  text-align: center;
`;

export const Description = styled.div`
  margin-bottom: 12px;
  font-size: 0.875rem;
`;

export const Bar = styled.div`
  position: relative;
  width: 100%;
  height: 2px;
  background-color: #ebebeb;
`;

export const BarActive = styled.div.attrs(() => ({
  role: 'progressbar',
}))`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #000;
`;
